import React from 'react'
import { useTranslation } from 'react-i18next'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import VerticalSplitOutlined from '@mui/icons-material/VerticalSplitOutlined'

import { PostingScreen } from '../../../types/types'

import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import { PostingTemplate } from '@professocial/professocialTypes/types/commonTypes'
import { UserSettings } from '@professocialApi/professocial-core-frontend-api/models/UserSettings'
import { useSelector } from 'react-redux'
import { getUser } from '../../../../store/common/common.selectors'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    textTransform: 'inherit',
    marginRight: '30px',
  },
  icon: {
    verticalAlign: 'top',
  },
}))

interface IProps {
  posting: PostingTemplate
  changePosting?: (post: PostingTemplate) => void
  changePostingScreen?: (screen: PostingScreen) => void
}

const SelectTemplate: React.FC<IProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const user: UserSettings = useSelector(getUser)

  return (
    <>
      <ButtonComponent
        variant='text'
        className={classes.root}
        color='info'
        text={
          <>
            <span style={{ paddingRight: '10px' }}>
              <VerticalSplitOutlined className={classes.icon} style={{ fontSize: '26px' }} />
            </span>
            <span>{user.role === 'USER' ? t('postingCommon:chooseTemplate') : t('postingCommon:chooseTemplateEditor')}</span>
          </>
        }
        onClick={() => props.changePostingScreen && props.changePostingScreen(PostingScreen.TEMPLATE)}
      />
    </>
  )
}

export default SelectTemplate
